<template>
	<div id="help" class="fullSize">

		<div id="help_panel"
		v-bind:class="App.help.miniOpen && App.getHelpMini() != '' ? 'opened': 'closed'">

			<div id="help_panel_toggle"
			v-on:click="toggleMiniHelp()"></div>
			<div class="help_panel_content"
			v-html="App.getHelpMini()"></div>

		</div>
	</div>
</template>

<script>
export default {
	name: 'Help',
	props: {
		App: Object
	},
	data : function() {
		return {
			
		}
	},
	mounted() {
		
	},
	created() {
	},
	methods : {

		toggleMiniHelp() {
			this.App.help.miniOpen = !this.App.help.miniOpen

			if(this.App.help.miniOpen)
				document.body.classList.add("help");
			else
				document.body.classList.remove("help");
		}

	}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>
